module.exports = __webpack_public_path__ + "static/media/kids-group.43f27a3b.png";